export default __webpack_public_path__ + "static/camara-comercio-f8549bd6e0b1f722c40bc6e62e7f8d13.jpg";